import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../theme';
import { AlertMessage } from '../AlertMessage';
import { HorizontalRule } from '../HorizontalRule';

export const StyledLink = styled('a')`
    font-weight: bold;
    color: ${({ theme }: { theme: Theme }) => theme.palette.primary.dark};
    text-decoration: none;
    & :hover {
        color: ${({ theme }: { theme: Theme }) => theme.palette.primary.dark};
    }
`;

export const StyledHorizontalRule = styled(HorizontalRule)`
    /* stylelint-disable unit-allowed-list */
    margin: ${({ theme }: { theme: Theme }) =>
        theme.tggSpacing([rem(3), 0], [12, 0])};

    ${({ theme }) => theme.breakpoints.up('desktop')} {
        margin: ${({ theme }: { theme: Theme }) =>
            theme.tggSpacing([rem(6), 0], [24, 0])};
    }
`;

export const StyledAlertMessage = styled(AlertMessage)`
    margin-bottom: ${({ theme }: { theme: Theme }) =>
        theme.tggSpacing(rem(2), 8)};
`;
